import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppFooterModule } from '../../../../libs/Shared/components/swipesum-footer/swipesum-footer.module';
import { AppHeaderModule } from '../../../../libs/Shared/components/swipesum-header/swipesum-header.module';
import { SwipesumAPI } from './core/swipesum';
import { environment } from '../environments/environment';
import { FirebaseService } from './services/firebase-service';
import { DocumentationPage } from './pages/documentation-page/documentation-page';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppFooterModule, AppHeaderModule, DocumentationPage],
  templateUrl: './app.html',
  styles: [],
})
export class App {
  windowLocation = window.location.pathname;
  protected readonly title = signal('suite-app');
  constructor(private readonly swipesumAPI: SwipesumAPI, private readonly firebaseService: FirebaseService){}
  async ngOnInit() {
    this.windowLocation = window.location.pathname;
    environment.firebaseConfig.apiKey = await this.swipesumAPI.apiCall('/firebase/config', 'GET', this.swipesumAPI.getDefaultHeaders(), null, null);
    this.firebaseService.setupFirebase();
  }

  onDocumentationClick() {
    window.location.href = `${environment.suiteUrl}/documentation`;
  }

  onLoginClick() {
    window.location.href = environment.suiteUrl;
  }
}
